import { StrapiComponent, StrapiFundData } from '@types'
import { FundQueryData } from '@contracts/fund/model.ts'
import get from 'lodash/get'

const strapiUrl = process.env.NEXT_PUBLIC_STRAPI_URL || ''

export const createStrapiUrl = (path: string): string => {
  if (!path) return ''
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path
  }
  return `${strapiUrl}${path}`
}

/** Resolve the inner media record from flat v5 or normalized v4 `{ data: { attributes } }` shapes. */
function getStrapiMediaRecord(media: unknown): Record<string, unknown> | null {
  if (!media || typeof media !== 'object' || Array.isArray(media)) return null
  const m = media as Record<string, unknown>
  if ('url' in m || 'formats' in m) return m
  const attrs = m.attributes
  if (
    attrs &&
    typeof attrs === 'object' &&
    !Array.isArray(attrs) &&
    ('url' in attrs || 'formats' in attrs)
  ) {
    return attrs as Record<string, unknown>
  }
  const data = m.data
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null
  const record = data as Record<string, unknown>
  if (record.attributes && typeof record.attributes === 'object') {
    return record.attributes as Record<string, unknown>
  }
  return record
}

/** Extract a relative media path from Strapi media (supports flat and nested shapes). */
export function getStrapiMediaPath(media: unknown, subPath?: string): string {
  const record = getStrapiMediaRecord(media)
  if (!record) return ''
  if (subPath) {
    const value = get(record, subPath)
    return typeof value === 'string' ? value : ''
  }
  const url = record.url
  return typeof url === 'string' ? url : ''
}

export function createStrapiMediaUrl(media: unknown, subPath?: string): string {
  return createStrapiUrl(getStrapiMediaPath(media, subPath))
}

export const getFundQueryDataFromStrapiData = (
  data: StrapiComponent<StrapiFundData>[] | undefined,
): FundQueryData[] => {
  if (!data?.length) return []

  const addresses = data
    .filter(({ fundAddress }) => !!fundAddress)
    .map(({ fundAddress, type, fundFilterType }) => ({
      address: fundAddress,
      type,
      fundFilterType,
    }))

  return addresses
}
